import { gtm } from 'root/utils/tracking/googleTagManagerDeprecated';
import { CookieMonster } from 'root/utils/cookies/cookieMonster';
import { GoogleTagManager } from 'root/utils/tracking/GA4/googleTagManager';

export default function businessTypeSelectionModule(btsModules) {
    return (function () {
        const init = () => {
            btsModules.forEach(btsModule => {
                const isMobile = window.innerWidth < 600;
                const productPanel = btsModule.querySelector(
                    '[data-module-bts="panel-product"]'
                );
                const panelShowClass = 'js-business-type-selection-module__panel--show';
                const panelAnimateClass =
                    'js-business-type-selection-module__panel--animate';
                if (productPanel) {
                    const productPanelHeight = productPanel.scrollHeight;
                    const productButtons = Array.from(
                        productPanel.querySelectorAll('[data-module-bts-product]')
                    );
                    const backButtons = btsModule.querySelectorAll(
                        '[data-module-bts="back-button"]'
                    );

                    /**
                     * This hides the product panel and shows the business type panel associated with the selected product
                     * @param {*} productButton
                     */
                    const showAssociatedBTPanel = product => {
                        const associatedPanel = btsModule.querySelector(
                            `[data-module-bts="panel-${product}"]`
                        );
                        productPanel.classList.remove(panelShowClass);
                        if (associatedPanel) {
                            isMobile &&
                                (btsModule.style.minHeight = `${associatedPanel.scrollHeight}px`);
                            associatedPanel.classList.add(
                                panelShowClass,
                                panelAnimateClass
                            );
                        }
                    };

                    /**
                     * This hides the current business type panel and shows the product panel
                     * @param {*} backButton
                     */
                    const hideBTPanel = backButton => {
                        backButton
                            .closest('[data-module-bts*="panel"]')
                            .classList.remove(panelShowClass, panelAnimateClass);
                        productPanel.classList.add(panelShowClass);
                    };

                    productButtons.forEach(productButton => {
                        productButton.addEventListener('click', () => {
                            const product = productButton.dataset.moduleBtsProduct;
                            if (product) {
                                gtm.btSelectionModule(product).sendEvent(
                                    'business-type-selection-module'
                                );
                                if (productButton.tagName === 'BUTTON') {
                                    showAssociatedBTPanel(product);
                                }
                            }
                        });
                    });
                    backButtons.forEach(backButton => {
                        backButton.addEventListener('click', () => {
                            hideBTPanel(backButton);
                            isMobile &&
                                (btsModule.style.minHeight = `${productPanelHeight}px`);
                            gtm.btSelectionModule('back').sendEvent(
                                'business-type-selection-module'
                            );
                        });
                    });
                }
                // This shows and animates the first panel of the Business Type Selection Module content when it scrolls into the viewport. On the two-step version, it's the Product panel, while on the one-step, it's the Retail or Resto panel.
                const initialShownPanel = btsModule.querySelector(`.${panelShowClass}`);
                try {
                    /* this is a fix for "ReferenceError: IntersectionObserver is not defined" in case on an Android devices where the IntersectionObserver won't be defined - recurrent error in DD */
                    const btsModuleObserver = new IntersectionObserver(
                        (entries, observer) => {
                            entries.forEach(entry => {
                                if (entry.isIntersecting) {
                                    entry.target.classList.add(panelAnimateClass);
                                    observer.unobserve(entry.target);
                                }
                            });
                        },
                        { threshold: 0.5 }
                    );
                    btsModuleObserver.observe(initialShownPanel);
                } catch (e) {
                    console.warn(e); /* @todo Send a DD custom event */
                    initialShownPanel.classList.add(panelAnimateClass);
                }
                // Fire Tracking event when a business type is clicked on
                const businessTypeButtons = btsModule.querySelectorAll(
                    '[data-module-bts-business-type]'
                );
                businessTypeButtons.forEach(businessTypeButton => {
                    businessTypeButton.addEventListener('click', () => {
                        const businessType =
                            businessTypeButton.dataset.moduleBtsBusinessType;
                        if (businessType) {
                            GoogleTagManager.sendEvent({
                                event_action: 'click_business_type',
                                business_type: businessType,
                            });
                            gtm.btSelectionModule(businessType).sendEvent(
                                'business-type-selection-module'
                            );
                        }
                    });
                });

                // Clear BT cookie when "Other" business type is clicked on
                const clearCookieButtons = document.querySelectorAll(
                    '[data-module-bts-clear-cookie]'
                );
                const cm = new CookieMonster();
                clearCookieButtons.forEach(clearCookieButton => {
                    clearCookieButton.addEventListener('click', () => {
                        cm.unsetCookie('ls_vertical_bt');
                        window.localStorage.removeItem('btf.businessType');
                    });
                });
            });
        };
        return {
            init,
        };
    })().init();
}
